document.addEventListener('alpine:init', () => {
    Alpine.data('admin_attach_billing_show_x_data', () => ({
        attach_billing(url) {
            const sub_id_input = this.$refs.sub_id_x_ref
            // post fetch request using submit url
            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
                },
                body: JSON.stringify({
                    new_sub_id: sub_id_input.value
                })
            }).then(response => {
                return response.json();
            }).then(data => {
                alert(data.message)
            }).catch(error => {
                alert(error)
            });
        }
    }));
});